import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { ProjectTemplateListItem } from "tekkr-common/dist/model/project/project-template";

export function useListTemplatesQuery() {
    return useQuery({
        queryKey: ["templates"],
        queryFn: async (): Promise<ProjectTemplateListItem[]> => {
            const res = await apiClient.listProjectTemplates();
            if (res.status !== 200) {
                throw new Error("Failed to fetch templates");
            }
            return res.body.data;
        },
    });
}
